/**
 * Функции по работе с MessageChannel и его портами
 * https://developer.mozilla.org/en-US/docs/Web/API/MessageChannel
 * https://dbaron.org/mozilla/zero-timeout
 * используем MessageChannel как альтернативу setTimeout(() => {}, 0)
 */
const messageChannel = new MessageChannel();
messageChannel.port1.start();

export function yieldToMain(): Promise<void> {
  return new Promise((resolve) => {
    const listener = () => {
      resolve();
      messageChannel.port1.removeEventListener('message', listener);
    };
    messageChannel.port1.addEventListener('message', listener);
    messageChannel.port2.postMessage('');
  });
}

export function callToMain(fn: VoidFunction) {
  yieldToMain().then(fn);
}
